import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UploadPicture, UpdateProfile } from "../../redux/slices/profile";
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import PhoneInput from "react-phone-input-2";
const schema = yup.object().shape({
  name: yup.string().required("Username is required"),
  email: yup
    .string()
    .email("Invalid email format")
    .required("Email is required"),
  phone: yup.string().required("Phone number is required"),
});
const Userprofile = () => {
  const { user } = useSelector((value) => value.login);
  const dispatch = useDispatch();
  const uploadPictureImage = (event) => {
    const file = event.target.files[0];
    if (file) {
      dispatch(UploadPicture(file));
    }
  };

  const { loading, ploading } = useSelector((v) => v.selfie);

  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      name: user?.name || "",
      email: user?.email || "",
      phone: user?.phone || "",
    },
  });

  const onSubmit = async (data) => {
    try {
      dispatch(UpdateProfile(data));
    } catch (error) {
      alert("Error updating profile. Please try again.");
    }
  };

  return (
    <>
      <section className="profile-section flex-1 pb-20">
        <div className="container">
          <div className="profile-edit-wrapper mx-auto">
            <div className="row gy-5">
              <div className="col-xl-4">
                <div className="profile__thumb__edit text-center p-4 custom-border">
                  <div className="card--body">
                    <div className="thumb">
                      <img
                        src={user?.image ? user?.image : "/images/user.png"}
                        alt="Profile"
                        className="rounded-circle w-32 h-32 mr-2"
                      />
                    </div>
                    <div className="profile__info">
                      <h4 className="name">{user?.name}</h4>
                      {/* <p className="username">@demouser123</p> */}
                      <input
                        type="file"
                        className="form-control d-none "
                        id="update-photo"
                        disabled={ploading}
                        onChange={uploadPictureImage}
                      />
                      <label
                        className="cmn--btn active btn--md mt-3"
                        for="update-photo"
                      >
                        {ploading ? (
                          <div
                            className="spinner-border text-light"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          "Update Profile Picture"
                        )}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-8">
                <form
                  onSubmit={handleSubmit(onSubmit)}
                  className="card--lg custom-border bg-[#280203] text-white border-2 rounded-lg p-5 md:p-2"
                >
                  <div className="row gy-3">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="name" className="form-label">
                          Username
                        </label>
                        <input
                          id="name"
                          {...register("name")}
                          type="text"
                          disabled={loading}
                          className={`form-control form--control style-two ${
                            errors.name ? "is-invalid" : ""
                          }`}
                          placeholder="Enter Username"
                        />
                        {errors.name && (
                          <small className="text-red-500">
                            {errors.name.message}
                          </small>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="email" className="form-label">
                          Email Address
                        </label>
                        <input
                          id="email"
                          disabled={true}
                          {...register("email")}
                          type="email"
                          className="form-control form--control style-two"
                          readOnly
                        />
                      </div>
                    </div>
                    <div className="col-xl-12 col-md-12">
                      <div className="form-group custom-phoneinput style--two">
                        <Controller
                          name="phone"
                          control={control}
                          render={({ field }) => (
                            <PhoneInput
                              {...field}
                              country={"us"}
                              disabled={loading}
                              onChange={(phone) => field.onChange(phone)}
                              inputclassName={`form--control form-control style--two ${
                                errors.phone ? "is-invalid" : ""
                              }`}
                              buttonclassName="btn--custom-dropdown"
                              placeholder="Phone Number"
                            />
                          )}
                        />
                        {errors.phone && (
                          <div className="invalid-feedback absolute left-0 text-left mt-0 text-[12px]">
                            {errors.phone.message}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col">
                      <button
                        type="submit"
                        disabled={loading}
                        className="mt-10 px-6 py-2 text-black font-bold rounded-lg bg-gradient-to-b from-yellow-400 to-yellow-600 shadow-md hover:from-yellow-500 hover:to-yellow-700 transition duration-300"
                      >
                        {loading ? (
                          <div
                            className="spinner-border text-light"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          "Update Profile"
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Userprofile;
